import { render, staticRenderFns } from "./DetallesValuador.vue?vue&type=template&id=6347ad75&scoped=true"
import script from "./DetallesValuador.vue?vue&type=script&lang=js"
export * from "./DetallesValuador.vue?vue&type=script&lang=js"
import style0 from "./DetallesValuador.vue?vue&type=style&index=0&id=6347ad75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347ad75",
  null
  
)

export default component.exports